





















import Vue from "vue";
import foodImage from "@/assets/images/food.png";

export default Vue.extend({
  props: {
    badge: { type: Number },
    noImage: { type: String, default: undefined, required: false },
    fonts: { type: Object },
    colors: { type: Object },
    menuColumnsCount: { type: Number, default: 2 }
  },
  data() {
    return {
      foodImage
    };
  }
});
